const DeliveryAddressView = () => import('./screens/index.vue')

import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';
import { checkUserPermissions } from '@/services/auth';

export const deliveryAddressRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.ADDRESS_ADM_VIEW,
    PERMISSIONS_KEYS.ADDRESS_ADM_BLOCK,
    PERMISSIONS_KEYS.ADDRESS_ADM_UNBLOCK,
  ])
) {
  deliveryAddressRoutes.push({
    path: '/enderecos/entrega',
    name: 'Cadastro / Consulta|Endereço de Entrega',
    component: DeliveryAddressView,
    meta: {
      icon: 'fa-sliders-h',
      requiresAuth: true,
    },
  });
}
